
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TextareaAutogrowDirective } from 'vue-textarea-autogrow-directive';
import Toasted from 'vue-toasted';
import { handleError } from '../../../../api';
import { WindowType } from '../../../../util';
import { Card, Comment, CommentReply, UserBase } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';
import TextSuggest from '../../../textsuggest/TextSuggest';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'Details',
  components: {
    Comment: require('../comment/comment.vue.html').default,
    TextSuggest,
  },
  directives: {
    'autogrow': TextareaAutogrowDirective,
  },
})
export default class Details extends Vue {
  @Prop({ required: true })
  state!: KanbanState;
  @Prop({ required: true })
  card!: Card;
  @Prop({ default: false })
  readonly!: boolean;
  @Prop({ default: false })
  lockeddown!: boolean;
  @Prop({ default: [] })
  userEmails!: string[];

  newComment: string = '';

  commentCreate(): void {
    if (this.readonly) {
      return;
    }

    const card = this.card;
    let c = new Comment();
    c.aspNetUserId = window.application.kanban.user?.id!;
    c.cardId = card.id;
    c.commentReplies = [];
    c.createdOn = new Date();
    c.text = this.newComment;

    //save to backend
    this.state.commentAPI.create(c)
        .then(e => {
          this.$toasted.info(this.$t('txtSaved').toString());
          if (!card.comments)
            card.comments = [];
          card.comments.push(e.result!);

          this.newComment = '';
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  commentSave(comment: Comment, text: string): void {
    if (this.readonly) {
      return;
    }

    let tmp = comment.clone();
    tmp.text = text;

    //save to backend
    this.state.commentAPI.update(tmp)
        .then(_ => {
          this.$toasted.info(this.$t('txtSaved').toString());
          comment.text = text;
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  commentDelete(comment: Comment): void {
    if (this.readonly) {
      return;
    }

    const card = this.card;
    const index = (card.comments ?? []).findIndex(e => e.id === comment.id);
    if (index > -1) {
      //save to backend
      this.state.commentAPI.delete(comment.id!)
          .then(_ => {
            this.$toasted.info(this.$t('txtDeleted').toString());
            card.comments?.splice(index, 1);
          })
          .catch(e => handleError(this.$toasted, this.$i18n, e));
    }
  }

  replyCreate(comment: Comment, text: string): void {
    if (this.readonly) {
      return;
    }

    let apireply = new CommentReply();
    apireply.aspNetUserId = window.application.kanban.user?.id!;
    apireply.commentId = comment.id;
    apireply.createdOn = new Date();
    apireply.text = text;

    //save to backend
    this.state.replyAPI.create(apireply)
        .then(e => {
          this.$toasted.info(this.$t('txtSaved').toString());

          e.result!.aspNetUser = new UserBase(window.application.kanban.user);

          if (!comment.commentReplies)
            comment.commentReplies = [];
          comment.commentReplies.push(e.result!);
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  replySave(comment: Comment, reply: CommentReply, text: string): void {
    if (this.readonly) {
      return;
    }

    reply.text = text;

    //save to backend
    this.state.replyAPI.update(reply)
        .then(_ => this.$toasted.info(this.$t('txtSaved').toString()))
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }

  replyDelete(comment: Comment, reply: CommentReply): void {
    if (this.readonly) {
      return;
    }

    const index = (comment.commentReplies ?? []).findIndex(e => e.id === reply.id);
    if (index > -1) {
      //save to backend
      this.state.replyAPI.delete(reply.id!)
          .then(_ => {
            this.$toasted.info(this.$t('txtDeleted').toString());
            comment.commentReplies?.splice(index, 1);
          })
          .catch(e => handleError(this.$toasted, this.$i18n, e));
    }
  }
}
